import { Autocomplete, Box, IconButton, InputBase, MenuItem, Select, TextField } from "@mui/material";
import {useState} from "react";
import PAGEDOWN from "../../../../../asset/image/pagination_down.svg"
import ChevronLeftRoundedIcon from '@mui/icons-material/ChevronLeftRounded';
import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import LastPageIcon from '@mui/icons-material/LastPage';

const TablePagination = (props) => {
    const {rowsPerPageOptions, rowsPerPage, onRowsPerPageChange, page, totalRowCount, onPageChange, } = props;

    const totalPages = Math.ceil((totalRowCount ?? 0) / (rowsPerPage ?? 10));
    const pageOptions = Array.from({ length: totalPages }, (_, i) => i + 1); 
    const [pagevalue, setPagevalue] = useState(1);

    const renderIcon = () => {
        return <img alt="dropdown" className="rowsSelectIcon" src={PAGEDOWN} />
    }

    return (
        
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          px={2}
          py={1.5}
          sx={{
            backgroundColor: '#F5F5F5',
            position: 'sticky',
            left: 0,
            // borderTop: '1px solid #E1E1E1',
            // borderBottom: '1px solid #E1E1E1',
            fontSize: '14px',
          }}
        >
          {/* Left Side: RowsPerPage, Label, PageSelect, Page Range, Arrows */}
          <Box display="flex" alignItems="center" gap={"10px"}>
            {rowsPerPageOptions.length > 1 && (
                <Select
                  className="rowsSelect"
                  variant="outlined"
                  value={rowsPerPage}
                  input={<InputBase className="row-dropdown" />}
                  onChange={(e) => {
                    const newLimit = Number(e.target.value);
                    onRowsPerPageChange?.(newLimit);
                  }}
                  IconComponent={renderIcon}
                >
                  {rowsPerPageOptions.map((opt) => (
                    <MenuItem className="records-select-item" key={opt} value={opt}>
                      {opt}
                    </MenuItem>
                  ))}
                </Select>
            )}
            {/* Items from */}
            <span className="paginationHighDarkElement">
              Items per page
            </span>  

            {/* eg 1–10 of 63 pages */}
            <span className="paginationHighElement">
              {`${((page ?? 1)-1) * (rowsPerPage ?? 10) + 1}-${Math.min(((page ?? 1)) * (rowsPerPage ?? 10),totalRowCount ??  0)}`}
            </span>
            <span className="paginationElement">
                {`of`}
            </span>
            <span className="paginationHighElement">
                {`${totalRowCount ?? 0}`}
            </span>
            <span className="paginationHighElement">
                {`items`}
            </span>
          </Box>
          <div className="displayFlex" style={{gap:"8px"}}>
          <Autocomplete
            options={pageOptions}
            value={(page ?? 1)}
            onChange={(_, newValue) => {
              if (newValue !== null) {
                onPageChange?.(newValue, rowsPerPage ?? 10);
              }
            }}
            onInputChange={(e, newInput) => {
                const parsed = parseInt(newInput);
                setPagevalue(parsed);
            }}
            disableClearable
            size="small"
            isOptionEqualToValue={(option, value) => option === value}
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder=""
                inputProps={{
                  ...params.inputProps,
                }}
              />
                )}
            sx={{
              width: '56px',
              height: '23px',
              '& .MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-colorPrimary': {
                padding: '0px', // space for the dropdown icon
                borderRadius: '4px',
                fontFamily: 'Inter',
                fontWeight: 400,
                fontSize: '14px',
                lineHeight: '100%',
                color: '#6E7079',
                },
              '& .MuiOutlinedInput-notchedOutline': {
                borderColor: '#C4C4C4',
              },
              '& .MuiAutocomplete-popupIndicator': {
                padding: '0px',
              },
              '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
                display: 'none',
              },
            }}
          />
            <span className="paginationElement">
                {`of`}
            </span>
            <span className="paginationHighElement"> 
              {`${Math.ceil((totalRowCount ?? 0) / (rowsPerPage ?? 10 ))}`}</span>
            <span className="paginationElement">
                {`pages`}
            </span>
            {/*arrows */}
            <Box>
              <IconButton 
                onClick={() => {
                  onPageChange?.(1, rowsPerPage ?? 10)
                }} 
                disabled={page === 1}
                sx={{
                  width: '20px',
                  height: '20px',
                  color: page === 1 ? '#C4C4C4' : '#45464E',
                  padding: '4px',
                  fontSize: '20px'
                }}
                >
                <FirstPageIcon sx={{fontSize: '20px'}}/>
              </IconButton>
              <IconButton
                size="small"
                onClick={() => {
                  onPageChange?.(Math.max((page ?? 1) - 1, 1), rowsPerPage ?? 10);
                  }}
                disabled={page === 1}
                sx={{
                  width: '20px',
                  height: '20px',
                  color: page === 1 ? '#C4C4C4' : '#45464E',
                  padding: '4px',
                }}
              >
                <ChevronLeftRoundedIcon sx={{ fontSize: '20px' }} />
              </IconButton>
              <IconButton
                size="small"
                onClick={() => {
                  const totalPages = Math.ceil((totalRowCount) / (rowsPerPage ?? 10));
                  onPageChange?.(Math.min((page ?? 1) + 1, totalPages), rowsPerPage ?? 10);
                }}
                disabled={((page ?? 1)) * (rowsPerPage ?? 10) >= (totalRowCount ?? 0)}
                sx={{
                  width: '20px',
                  height: '20px',
                  color: ((page ?? 1)) * (rowsPerPage ?? 10) >= (totalRowCount ?? 0) ? '#C4C4C4' : '#45464E',

                  padding: '4px',
                }}
              >
                <ChevronRightRoundedIcon sx={{ fontSize: '20px' }} />
              </IconButton>
              <IconButton 
                onClick={() => {
                  const totalPages = Math.ceil((totalRowCount) / (rowsPerPage ?? 10));
                  onPageChange?.(totalPages, rowsPerPage ?? 10)
                }} 
                disabled={((page ?? 1)) * (rowsPerPage ?? 10) >= (totalRowCount ?? 0)}
                sx={{
                  width: '20px',
                  height: '20px',
                  color: ((page ?? 1)) * (rowsPerPage ?? 10) >= (totalRowCount ?? 0) ? '#C4C4C4' : '#45464E',

                  padding: '4px',
                }}
              >
                <LastPageIcon sx={{fontSize: '20px'}}/>
              </IconButton>
            </Box>
          </div>
        </Box>
    )
}

export default TablePagination;